import { Container } from '@chakra-ui/react';
import { FC } from 'react';

import { Section } from '@/components/ui/core/Section/Section';
import { EventListGrid } from '@/components/ui/features/ hubs-conferences/EventListGrid/EventListGrid';

export const EventListContent: FC = () => {
  return (
    <Container>
      <Section mt={4} pb={{ base: 28, lg: 40 }} variant="dimmed" display="block">
        <EventListGrid />
      </Section>
    </Container>
  );
};
